import { get } from "../../axios"

export function frontConfig(){

    return get("config/front")
}

export function checkLicence(){

    return get("licence/checkLicence")
}

export function getLicenceData(){

    return get("licence/getLicenceData")
}



// WEBPACK FOOTER //
// ./src/api/config/index.js